const handleCustomerDetailsForm = () => {
  const $form = $('.js-customer-details-form form');
  const $messagesContainer = $form.find('.form__messages');
  const $errorMessages = $messagesContainer.find('.form__message--error');
  const $successMessages = $messagesContainer.find('.form__message--success');

  Accentuate($form, function(data) {
    if (data.status === 'ERROR') {
      $errorMessages.find('ul').html('');

      for (let key in data.errors) {
        if (data.errors.hasOwnProperty(key)) {
          const $errorTemplate = $(`<li>${key} ${data.errors[key]}</li>`);

          $errorTemplate.appendTo($errorMessages.find('ul'))
        }
      }

      $errorMessages.removeClass('hidden');
      $successMessages.addClass('hidden');
    } else {
      $errorMessages.addClass('hidden');
      $successMessages.removeClass('hidden');
    }
  });
}

handleCustomerDetailsForm();

